import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select'

export interface AppSelectProps<TValue> {
  id?: string
  options: { label: string; value: TValue }[]
  className?: string
  onChange?: (value: TValue | null) => void
  value?: TValue
  defaultValue?: TValue
  ariaInvalid?: boolean
  placeholder?: string
  size?: 'sm' | 'default' | 'xs' | '2xs'
}

export function AppSelect<TValue>({
  id,
  options,
  onChange,
  className,
  value,
  defaultValue,
  ariaInvalid,
  placeholder,
  size = 'default',
}: AppSelectProps<TValue>) {
  const allOptions = placeholder ? [{ label: placeholder, value: null }, ...options] : options

  return (
    <Select
      id={id}
      items={allOptions}
      value={value}
      defaultValue={defaultValue}
      onValueChange={(value) => {
        onChange?.(value)
      }}
    >
      <SelectTrigger className={className} aria-invalid={ariaInvalid} size={size}>
        <SelectValue />
      </SelectTrigger>

      <SelectContent alignItemWithTrigger={false}>
        {allOptions.map((option) => (
          <SelectItem key={option.label} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
